/** 模板弹窗的可恢复地址。只传递明确的展示上下文，不携带任意查询参数。 */
export function buildTemplateEntryHref(
  templateId: string,
  options: { locale?: string; sourceLanding?: string | null; variant?: string | null } = {},
): string {
  const params = new URLSearchParams();
  if (options.locale === 'en' || options.locale === 'zh') params.set('lang', options.locale);
  if (options.sourceLanding?.startsWith('/') && !options.sourceLanding.startsWith('//')) {
    params.set('source_landing', options.sourceLanding);
  }
  if (options.variant) params.set('variant', options.variant);
  const search = params.toString();
  return `/t/${encodeURIComponent(templateId)}${search ? `?${search}` : ''}`;
}

export function buildTemplateLoginHref(templateId: string, search: string, locale: string, variant?: string | null, studioPath?: string | null): string {
  const current = new URLSearchParams(search);
  const sourceLanding = current.get('source_landing');
  const templateHref = buildTemplateEntryHref(templateId, {
    locale,
    sourceLanding,
    variant: variant ?? current.get('variant'),
  });
  // Only the five standalone tool routes may replace the canonical template path.
  // Preserve the same allowlisted presentation query and reject arbitrary redirects.
  const isStudioPath = typeof studioPath === 'string'
    && /^\/tools\/(virtual-try-on|outfit-extension|silhouette-extension|white-background|lookbook)$/.test(studioPath);
  const queryIndex = templateHref.indexOf('?');
  const redirect = isStudioPath ? `${studioPath}${queryIndex < 0 ? '' : templateHref.slice(queryIndex)}` : templateHref;
  const params = new URLSearchParams({ redirect, login: '1' });
  if (locale === 'en' || locale === 'zh') params.set('lang', locale);
  if (sourceLanding?.startsWith('/') && !sourceLanding.startsWith('//')) params.set('source_landing', sourceLanding);
  return `/login?${params.toString()}`;
}
